import { useCallback, useMemo, useEffect } from 'react';

import { useAppSelector, useAppDispatch } from 'store/store-hooks';
import { EMPTY_CELL, Cells } from 'components/app/editor/_mediator/editor.slice';
import { setFcClipRates } from 'components/app/finalcuts/_mediator/fc-data.slice';
import { getPlaybackParams, getConfigRate } from './clip-playback.helper';

export const useClipPlaybackFc = () => {
  const { fcClipsMap, fcLinkedClips, fcStoryBoard, fcCells, fcStoryConfig } = useAppSelector((state) => state.fc__data);
  const dispatch = useAppDispatch();

  const fcClipsDataMap = useMemo(
    () =>
      fcStoryBoard.map((clipId) => {
        if (!fcClipsMap || clipId === EMPTY_CELL) return null;
        const clip = fcClipsMap[clipId];

        if (!clip) {
          console.error(`[use-clip-playback-fc.ts] clipData not found`, { clipId });
        }

        return clip;
      }),
    [fcStoryBoard, fcClipsMap]
  );

  const getFcClipPlaybackMap = useCallback(
    (cells: Cells) => {
      return fcClipsDataMap.reduce(
        (clipPlayback, clipData, index) =>
          clipData
            ? {
                ...clipPlayback,
                [clipData.clipId]: getPlaybackParams({
                  cellDuration: cells.duration[index],
                  configRate: getConfigRate(clipData, fcStoryConfig),
                  index,
                  clipData,
                  clipsMap: fcClipsMap,
                  linkedClips: fcLinkedClips,
                }).rate,
              }
            : clipPlayback,
        {}
      );
    },
    [fcStoryBoard, fcClipsMap]
  );

  useEffect(() => {
    if (!fcCells) return;
    dispatch(setFcClipRates(getFcClipPlaybackMap(fcCells)));
  }, [fcCells]);
};
